import { render, staticRenderFns } from "./ml-ruler-normal.vue?vue&type=template&id=35ba67f9&scoped=true&"
import script from "./ml-ruler-normal.vue?vue&type=script&lang=js&"
export * from "./ml-ruler-normal.vue?vue&type=script&lang=js&"
import style0 from "./ml-ruler-normal.vue?vue&type=style&index=0&id=35ba67f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba67f9",
  null
  
)

export default component.exports